import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const SubscriptionCancel = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white p-4">
            <div className="text-center max-w-md">
                <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6">
                    <XCircle className="w-8 h-8 text-amber-600" />
                </div>
                
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Payment Cancelled
                </h1>
                
                <p className="text-slate-600 mb-8">
                    No worries! Your payment was cancelled and you haven't been charged.
                    You can still use the free features or try again when you're ready.
                </p>

                <div className="space-y-3">
                    <Button 
                        onClick={() => navigate('/subscription')} 
                        className="w-full"
                    >
                        Try Again
                    </Button>
                    
                    <Button 
                        variant="outline" 
                        onClick={() => navigate('/calendar')}
                        className="w-full"
                    >
                        Continue with Free
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCancel;
